(function(){
 'use strict';
 const guide=document.querySelector('[data-buce-context-guide]');
 const header=guide?.closest('.t4s-header__wrapper');
 if(!guide||!header||guide.dataset.headerBound)return;
 const mascot=guide.querySelector('.buce-context-guide__mascot');
 const bubble=guide.querySelector('.buce-context-guide__bubble');
 const action=guide.querySelector('.buce-context-guide__action');
 const inner=guide.querySelector('.buce-context-guide__inner');
 const identity=guide.closest('.buce-header-identity');
 if(!mascot||!bubble||!action||!inner||!identity)return;
 guide.dataset.headerBound='true';
 header.classList.add('buce-r40-header');
 const trigger=document.createElement('button');
 trigger.type='button';trigger.className='buce-header-guide-trigger';
 trigger.setAttribute('aria-label',guide.dataset.triggerCopy);
 trigger.setAttribute('aria-expanded','true');
 mascot.replaceWith(trigger);trigger.append(mascot);
 const panel=document.createElement('div');
 panel.className='buce-header-thought';panel.id='buce-header-thought';
 panel.append(bubble,action);
 inner.append(panel);trigger.setAttribute('aria-controls',panel.id);
 identity.parentElement.classList.add('buce-header-identity-col');
 const row=identity.parentElement.parentElement;
 const menu=Array.from(row.children).find(el=>el.querySelector('[data-menu-drawer],.t4s-push-menu-btn,.t4s-push-menu'));
 if(menu)menu.classList.add('buce-header-menu-col');
 else if(row.firstElementChild!==identity.parentElement)row.firstElementChild.classList.add('buce-header-menu-col');
 let timer,dismissed=false;
 function syncLabel(){
  const message=bubble.querySelector('[data-buce-guide-message]')?.textContent.trim()||'';
  bubble.title=message;action.setAttribute('aria-label',message+' '+action.textContent.trim());
 }
 function open(){clearTimeout(timer);syncLabel();panel.hidden=false;trigger.setAttribute('aria-expanded','true');guide.dataset.dismissed=String(dismissed);guide.dispatchEvent(new CustomEvent('buce:guide-visibility'));}
 function close(){dismissed=true;clearTimeout(timer);panel.hidden=true;trigger.setAttribute('aria-expanded','false');guide.dataset.dismissed='true';guide.dispatchEvent(new CustomEvent('buce:guide-visibility'));}
 function briefly(){
  syncLabel();if(dismissed)return;open();timer=setTimeout(()=>{
   if(!panel.contains(document.activeElement)){
    guide.dispatchEvent(new CustomEvent('buce:guide-idle'));syncLabel();
   }
  },8000);
 }
 trigger.addEventListener('click',()=>{
  if(panel.hidden){dismissed=false;guide.dispatchEvent(new CustomEvent('buce:guide-greet'));open();}else close();
 });
 guide.addEventListener('buce:guide-dismiss',close);
 guide.addEventListener('buce:guide-message',briefly);
 guide.addEventListener('buce:guide-reaction',briefly);
 header.addEventListener('keydown',e=>{if(e.key==='Escape'&&!panel.hidden){close();trigger.focus();}});
 open();
})();
